import { render, staticRenderFns } from "./ContextBar.vue?vue&type=template&id=5b5b52aa&"
import script from "./ContextBar.vue?vue&type=script&lang=js&"
export * from "./ContextBar.vue?vue&type=script&lang=js&"
import style0 from "./ContextBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports